import { render, staticRenderFns } from "./ShowContent.vue?vue&type=template&id=09c4d4db&"
import script from "./ShowContent.vue?vue&type=script&lang=js&"
export * from "./ShowContent.vue?vue&type=script&lang=js&"
import style0 from "./ShowContent.vue?vue&type=style&index=0&id=09c4d4db&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports